import PropTypes from 'prop-types';

export const AddressDefaultProps = {
  city: '',
  country: '',
  fax: '',
  name: '',
  phone1: '',
  phone2: '',
  postcode: '',
  street1: '',
  street2: '',
  street3: '',
};
export const AddressPropTypes = {
  city: PropTypes.string,
  country: PropTypes.string,
  name: PropTypes.string,
  postcode: PropTypes.string,
  street1: PropTypes.string,
  street2: PropTypes.string,
  street3: PropTypes.string,
};

export const PhonesDefaultProps = {
  phone1: '',
  phone2: '',
};

export const PhonesPropTypes = {
  phone1: PropTypes.string,
  phone2: PropTypes.string,
};

export const FaxDefaultProps = {
  fax: '',
};

export const FaxPropTypes = {
  fax: PropTypes.string,
};

export const EmailDefaultProps = {
  email: '',
};

export const EmailPropTypes = {
  email: PropTypes.string,
};
